<template>
  <div>
    <v-row>
      <v-col>
        <ModuleHeader>Migrador de ventas (BOKKA) </ModuleHeader>
      </v-col>
      <v-col><v-btn @click="cancelToogle = true" outlined color="error" class="mx-1">Borrar día
          migrado</v-btn></v-col>
    </v-row>


    <v-card flat>
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="12" md="3">
              <label>Fecha inicial</label>
              <div style="border-bottom: 1px solid; margin-bottom: -1px">
                <Datepicker :input-class="'v-input__control theme--light v-text-field dateinputClass '"
                  @input="getAperturas()" @selected="selectDate" :value="input_date.format('MM/DD/YYYY')"></Datepicker>
              </div>
            </v-col>
            <v-col v-if="false" cols="6" md="6">
              <div style="border-bottom: 1px solid; margin-bottom: -1px">
                <label>Fecha final</label>
                <Datepicker :input-class="'v-input__control theme--light v-text-field dateinputClass '"
                  @input="getAperturas()" @selected="selectDateFinal" :disabled-dates="disableDates"
                  :value="input_date_final.format('MM/DD/YYYY')"></Datepicker>
              </div>
            </v-col>
            <v-col md="3" cols="6" class="mt-3">
              <v-autocomplete @input="getAperturas()" label="Departamentos" v-model="selectDep" item-text="Nombre"
                item-value="id" :items="departamentos"></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" class="mt-3">
              <v-autocomplete label="Turno" v-model="selectTurno" item-value="Turno" item-text="Desc"
                :items="turnosList">
                <template v-slot:append-outer>
                  <v-btn @click="getAperturas()" small color="primary">Buscar turnos</v-btn>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col md="3" cols="6" class="mt-3">
              <v-autocomplete v-model="clientesSelected" :items="comp_clients" item-value="id" item-text="text"
                label="Cliente" multiple>
                <template v-slot:append-outer>
                  <v-btn small @click="clientesSelected = []" color="primary">Todos</v-btn>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col md="3" cols="6">
              <v-autocomplete label="Caja" @input="getAperturas()" v-model="selectCaja" item-value="id" item-text="Nomb"
                :items="data_cajas"></v-autocomplete>
            </v-col>
            <v-col md="3" cols="6">
              <v-select v-model="input_cajero" :items="cajeros" item-value="Id" item-text="Nomb"
                label="Cajero"></v-select>
            </v-col>
            <v-col md="3" cols="6">
              <v-text-field v-model="input_folio" label="Folio de Venta"></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-btn @click="
          getVentas();
        " color="success" class="ma-1">
          Buscar
        </v-btn>
      </v-card-text>
    </v-card>
    <v-alert v-if="isMigrated" prominent type="warning">
      <v-row align="center">
        <v-col class="grow">
          Las ventas seleccionadas se insertaran al final del dia {{ input_date.format('DD/MM/YYYY') }}. Se continuara
          con
          el
          ultimo folio.
        </v-col>
        <v-col class="shrink">

        </v-col>
      </v-row>
    </v-alert>
    <div style="margin-bottom:100px;">
      <v-row>
        <v-col md="12">
          <v-btn-toggle multiple>
            <v-btn v-if="(selectedRows.length > 0) && (totalVentasShow.length == selectedRows.length)"
              @click="clearAll()">
              <v-icon color="primary"> mdi-checkbox-marked</v-icon> {{ selectedRows.length }}
            </v-btn>
            <v-btn v-if="(selectedRows.length > 0) && (totalVentasShow.length != selectedRows.length)"
              @click="selectAll()">
              <v-icon> mdi-minus-box-outline</v-icon> {{ selectedRows.length }}
            </v-btn>
            <v-btn v-if="selectedRows.length == 0" @click="selectAll()">
              <v-icon>mdi-checkbox-blank-outline</v-icon>
            </v-btn>
          </v-btn-toggle>


        </v-col>

      </v-row>
      <div v-if="loadingData == true">
        <div>Cargando</div>
      </div>
      <v-data-table disable-pagination item-key="idUnico" hide-default-footer :items="ventas_comp" :headers="headers">
        <template v-slot:[`header.clave`]="{ header }">
          {{ header.text }}
          <v-menu v-model="tooltips" :close-on-content-click="false" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-filter</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-text>
                <v-combobox v-model="multiSearch[header.value]" :items="getUniqueValues('clave')"
                  :label="`Filtrar por ${header.text}`" clearable multiple></v-combobox>
              </v-card-text>
            </v-card>
          </v-menu>
        </template>
        <template #item="{ item }">
          <tr :class="[
            item.match ? 'activeClass' : '',
            item.prop ? 'backgroundProp' : '',
            item.camb ? 'backgroundCamb' : '',
          ]">
            <td>
              <v-icon @click="selecItemRow(item.id)" v-if="!selectedRows.includes(item.id) && !item.Mgrt"
                color="primary">
                mdi-checkbox-blank-outline
              </v-icon>
              <v-icon @click="selecItemRow(item.id)" v-if="selectedRows.includes(item.id) && !item.Mgrt"
                color="primary">
                mdi-checkbox-marked
              </v-icon>

              <b v-if="item.Mgrt">Migrado</b> <br />
              <b>{{ item.Folio }}</b>
            </td>
            <td>{{ item.FechaVenta }}</td>
            <td>
              {{ formatDate(item.FechaCreacion) }}
            </td>

            <td>
              {{ item.Cliente.Apodo }}
            </td>
            <td>{{ item.Cliente.Nombre }}</td>

            <td>
              {{ $pgsHelper.getById(cajeros, "Id", item.Cajero).Nomb }}
            </td>
            <td>{{ item.clave }}</td>
            <td>{{ item.TipoPago }}</td>
            <td>
              <b>${{ formatNumber(item.Cantidad) }} {{ item.moneda }}</b>
            </td>
            <td>{{ $pgsHelper.formatNumber(item.Total) }}</td>
            <!-- <td>{{ $pgsHelper.formatNumber(res.PropinaTotal) }}</td> -->
            <td>
              <b>{{
                $pgsHelper.formatNumber(item.PropinaTotal + item.Total)
              }}</b>
            </td>
            <td>
              <b v-show="!item.camb" v-bind:class="{
                'blue--text': item.Devos,
                'green--text': !item.Devos,
              }">{{ item.Devos ? "Devuelto" : "Activo" }}</b>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <modal v-model="showModal" :showFooter="false" title="Detalle de la venta">
      <resumenVenta :selectedRes="selectedRes" />
    </modal>
    <v-card class="cardTotal" width="100%">

      <template v-for="(pago, index) in totalSelected">
        <v-chip :key="index" class="ma-2" :color="(index == 'EFVO_MXN' || index == 'VISA/MC') ? 'success' : 'primary'">
          {{ index }} : $<b>{{ $pgsHelper.formatNumber(pago) }}</b>
        </v-chip>
      </template>

      <v-btn :color="(isMigrated) ? 'warning' : 'success'" @click="confirmDialog = true" block>
        Enviar {{ (isMigrated) ? "al final del dia " + input_date.format('DD/MM/YYYY') : "" }}</v-btn>
    </v-card>
    <v-dialog max-width="400" v-model="confirmDialog" persistent>
      <v-card :color="(isMigrated) ? 'warning' : 'white'" :dark="isMigrated">
        <v-card-title>
          {{ (isMigrated) ? 'Migrar al final del dia ' + input_date.format('DD/MM/YYYY') :
            'Migrar Ventas' }}</v-card-title>
        <v-card-text>
          <p v-if="!isMigrated">Se migraran todas las ventas seleccionadas al sistema de respaldo contable<br /></p>
          <p v-if="isMigrated">Las ventas seleccionadas se insertaran al final del dia
            {{ input_date.format('DD/MM/YYYY') }}.
            Se continuara con el ultimo folio.<br /></p>
          <b>Ventas: {{ selectedRows.length }}</b>
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="loading" :disabled="selectedRows.length == 0" color="success"
            @click="(!isMigrated) ? sendVentas() : sendVentasToEnd()" block> Migrar {{ (isMigrated) ?
              "al final del dia" + input_date.format('DD/MM/YYYY') : "" }} </v-btn>

        </v-card-actions>
        <v-card-actions class="mt-0">
          <v-btn v-if="!loading" @click="confirmDialog = false" block small color="error" text> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="400" v-model="cancelToogle" persistent>
      <v-card>
        <v-card-title>Borra un día migrado</v-card-title>
        <v-card-text>Selecciona el día que deseas borrar, las ventas migradas anteriormente seran borradas del sistema
          contable (Rojo)<br />
          <div style="border-bottom: 1px solid; margin-bottom: -1px">
            <Datepicker :input-class="'v-input__control theme--light v-text-field dateinputClass '"
              @selected="selectDateRevert" :value="(input_date_revert) ? input_date_revert.format('MM/DD/YYYY') : ''">
            </Datepicker>
          </div>
          <v-autocomplete @input="getAperturas()" label="Departamentos" v-model="departamentoRevert" item-text="Nombre"
            item-value="id" :items="departamentos"></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="loading" color="error" @click="revertMigrate" block> Borrar migración </v-btn>

        </v-card-actions>
        <v-card-actions class="mt-0">
          <v-btn v-if="!loading" @click="cancelToogle = false" block small color="error" text> Regresar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>


import Datepicker from "vuejs-datepicker";
import moment from "moment";
import modal from "../../MainComponents/modal.vue";
import { mapGetters } from "vuex";
import Modificadores from "../../../clases/Modificadores.js";
import resumenVenta from "../../MainComponents/resumenVenta.vue";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import ReporteMetodosPago from "../../../clases/PdfMakers/ReporteMetodosPago.js";
import ReporteMetodosPagoCliente from "../../../clases/PdfMakers/ReporteMetodosPagoCliente.js";
import TransaccionesExcelExporter from "../../../clases/ExcelMaker/ReporteTransaccionesExcel.js";
import Currencies from "../../../clases/Currencies.js";

export default {
  name: "ReporteTransacciones",
  components: {
    Datepicker,
    resumenVenta,
    modal,
  },
  props: ["hideMenu"],
  data() {
    return {
      isMigrated: false,
      cancelToogle: false,
      tooltips: false,
      multiSearch: {},
      headers: [

        { text: 'Folio Venta', value: 'Folio' },
        { text: 'Fecha', value: 'FechaVenta' },
        { text: 'Hora', value: 'FechaCreacion' },
        { text: 'Alias', value: 'Cliente.Apodo' },
        { text: 'Cliente', value: 'Cliente.Nombre' },
        { text: 'Cajero', value: 'Cajero' },
        { text: 'Clave', value: 'clave' },
        { text: 'Tipo Pago', value: 'TipoPago' },
        { text: 'Cantidad Metodo Pago', value: 'Cantidad' },
        { text: 'Total Venta', value: 'Total' },
        { text: 'Total Ticket', value: 'Total' },
        { text: 'Estatus', value: 'Devos' },
      ],
      selectedRows: [],
      confirmDialog: false,
      loading: false,
      Currency: Currencies,
      selectTurno: "ALL",
      aperturas: [],
      clientesSelected: [],
      meseros: [],
      showDevs: true,
      selectCaja: "",
      pagos: [],
      monedas: [],
      transaccion: "",
      loadingData: false,
      showEstad: false,
      departamentoRevert: null,
      input_date_revert: null,
      input_date: moment(),
      input_date_final: moment(),
      selectedRes: "",
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      cajero: "ALL",
      data_cajas: [],
      showModal: false,
      formKey: 0,
      data_ventas: [],
      data_devoluciones: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      selectDep: "AYB-SmokeHouse",
      cajeros: [{ id: "ALL", Nomb: "Todos" }],
      reservations: [],
      cantFilter: "",
      ventasSnapshot: [],
      devolucionesSnapshot: [],
    };
  },
  computed: {
    ...mapGetters(["getFirebaseApp"]),
    ...mapGetters(["getClientes", "getPDVPagosTipos", "getPDVMonedasLista"]),
    getPayMethods() {
      const pagos = {};

      this.$store.getters.getPDVPagosTipos.forEach((pago) => {
        if (pago.Moneda == "All") {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            pagos[pago.id + "_" + tipo.id] = {
              id: pago.id + "_" + tipo.id,
              Nombre: pago.Nombre + " " + tipo.Nombre,
            };
          });
        } else if (pago.Moneda == "None") {
          pagos[pago.id] = { id: pago.id, Nombre: pago.Nombre };
        } else {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            if (tipo.id == pago.Moneda) {
              pagos[pago.id + "_" + tipo.id] = {
                id: pago.id + "_" + tipo.id,
                Nombre: pago.Nombre + " " + tipo.Nombre,
              };
            }
          });
        }
      });

      return pagos;
    },
    totalSelected() {
      let totales = {}
      this.data_ventas.forEach((item) => {
        if (this.selectedRows.includes(item.id)) {
          if (item.camb) {
            if (!totales["EFVO_MXN"]) {
              totales["EFVO_MXN"] = 0
            }
            totales["EFVO_MXN"] += item.Cantidad
          } else {
            if (item.clave == "VISA_MXN" || item.clave == "MACA_MXN") {
              if (!totales["VISA/MC"]) {
                totales["VISA/MC"] = 0
              }
              totales["VISA/MC"] += item.Cantidad
            } else {
              if (!totales[item.clave]) {
                totales[item.clave] = 0
              }
              totales[item.clave] += item.Cantidad
            }

          }
        }
      })
      return totales
    },
    turnosList() {
      let dep = [
        {
          Turno: "ALL",
          Desc: "Todos",
          CajeroName: "Todos",
        },
      ];
      this.aperturas.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    departamentos() {
      let dep = [
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    ventas_comp() {
      this.data_ventas.forEach((venta) => {
        let totales = 0;
      });
      let data = this.data_ventas;
      let array = data.sort(function (a, b) {
        if (b.Folio > a.Folio) return -1;
        if (b.Folio < a.Folio) return 1;
      });
      return array.filter((item) => {
        return Object.entries(this.multiSearch).every(([key, values]) => {
          if (!values || values.length === 0) return true;
          //const field = this.config.fields.find((f) => f.value === key);
          const searchableValue = this.getFormattedValue(item, "clave");
          console.log(item, searchableValue)
          // Manejar valores múltiples en la columna (separados por comas)
          const itemValues = searchableValue
            .toString()
            .split(",")
            .map((v) => v.trim().toUpperCase()); // Normaliza cada valor

          // Verifica si algún valor del filtro está presente en los valores del ítem
          return values.some((value) =>
            itemValues.includes(value.toString().trim().toUpperCase())
          );
        });
      });
      //return array;
    },
    totalVentasShow() {
      let ventas = []
      this.ventas_comp.forEach((item) => {
        if (!ventas.includes(item.id) && !item.Mgrt) {
          ventas.push(item.id)
        }
      })
      return ventas
    },
    devoluciones_comp() {
      let data = this.data_devoluciones;

      let array = data.sort(function (a, b) {
        if (b.Folio > a.Folio) return -1;
        if (b.Folio < a.Folio) return 1;
      });
      return array;
    },
    selectedReserva() {
      return this.selectedRes;
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    contadoresTotales() {
      let dataContador = {};
      let encabezados = {};
      let totales = { Cambio: 0 };
      this.data_ventas.forEach((venta) => {
        if (!venta.prop && !venta.camb) {
          if (!dataContador[venta.Cajero]) {
            dataContador[venta.Cajero] = { Cambio: 0 };
          }
          encabezados[venta.clave] = true;
          if (!totales[venta.clave]) {
            totales[venta.clave] = 0;
          }
          /*if(venta.Cambio){
            dataContador[venta.Cajero]["Cambio"] = dataContador[venta.Cajero]["Cambio"] +  venta.Cambio.MXN
            totales["Cambio"] = totales['Cambio']+  venta.Cambio.MXN
        }*/
          if (!dataContador[venta.Cajero][venta.clave]) {
            dataContador[venta.Cajero][venta.clave] = venta.Cantidad;
            totales[venta.clave] = totales[venta.clave] + venta.Cantidad;
          } else {
            dataContador[venta.Cajero][venta.clave] =
              dataContador[venta.Cajero][venta.clave] + venta.Cantidad;
            totales[venta.clave] = totales[venta.clave] + venta.Cantidad;
          }
        }
      });

      this.data_devoluciones.forEach((dev) => {
        if (!dev.prop) {
          if (!dataContador[dev.Cajero]) {
            dataContador[dev.Cajero] = { Cambio: 0 };
          }
          if (!dataContador[dev.Cajero][dev.clave]) {
            dataContador[dev.Cajero][dev.clave] = 0 - dev.Cantidad;
            totales[dev.clave] = totales[dev.clave] - dev.Cantidad;
          } else {
            dataContador[dev.Cajero][dev.clave] =
              dataContador[dev.Cajero][dev.clave] - dev.Cantidad;
            totales[dev.clave] = totales[dev.clave] - dev.Cantidad;
          }
        }
      });

      this.ventasSnapshot.forEach((vnt) => {
        if (vnt.Props) {
          let propinas = Object.entries(vnt.Props);
          //let propsMxn = 0
          propinas.forEach((prop) => {
            encabezados[prop[0]] = true;
            if (!dataContador[vnt.Cajero][prop[0]]) {
              dataContador[vnt.Cajero][prop[0]] = 0;
            }
            dataContador[vnt.Cajero][prop[0]] =
              dataContador[vnt.Cajero][prop[0]] + prop[1].Cantidad;
            if (!totales[prop[0]]) {
              totales[prop[0]] = 0;
            }
            totales[prop[0]] = totales[prop[0]] + prop[1].Cantidad;
          });
        }
        if (vnt.Cambio) {
          if (dataContador[vnt.Cajero]) {
            dataContador[vnt.Cajero]["Cambio"] =
              dataContador[vnt.Cajero]["Cambio"] + (vnt.Cambio[Currencies.getCurrencyDefault()] || 0);
            totales["Cambio"] = totales["Cambio"] + (vnt.Cambio[Currencies.getCurrencyDefault()] || 0);
          }
        }
      });
      this.devolucionesSnapshot.forEach((dev) => {
        if (dev.Depr) {
          let propinas = Object.entries(dev.Depr);
          //let propsMxn = 0
          propinas.forEach((prop) => {
            if (!dataContador[dev.Cajero]) {
              dataContador[dev.Cajero] = {};
            }
            if (!dataContador[dev.Cajero][prop[0]]) {
              dataContador[dev.Cajero][prop[0]] = 0;
            }
            dataContador[dev.Cajero][prop[0]] =
              dataContador[dev.Cajero][prop[0]] - prop[1];
            totales[prop[0]] = totales[prop[0]] - prop[1];
          });
        }
      });
      return {
        dataContador: dataContador,
        encabezados: encabezados,
        totales: totales,
      };
    },
    comp_resumen_data() {
      let total_products = 0;
      let total_golf_round = 0;
      let total_proshop = 0;
      let total = 0;
      let total_pagos = 0;
      let totalCambio = 0;
      let total_pesos = 0;
      let total_propina_pesos = 0;
      let total_propina_dolar = 0;
      let total_dolar = 0;
      this.data_ventas.forEach((venta) => {
        let prod = Object.entries(venta.Catalogo);
        this.$pgsHelper.log(prod);
        prod.forEach((producto) => {
          if (producto[0] == "Golf_Round") {
            total_golf_round++;
          } else {
            total_proshop++;
          }
          total_products++;
        });
        total_pagos = total_pagos + venta.Cantidad;
        total = total + parseInt(venta.Total);
        totalCambio = totalCambio + (venta.Cambio[Currencies.getCurrencyDefault()] ? venta.Cambio[Currencies.getCurrencyDefault()] : 0);
        if (venta.moneda === Currencies.getCurrencyDefault()) {
          total_pesos = total_pesos + venta.Cantidad;
          total_propina_pesos = total_propina_pesos + venta.propina;
        } else {
          total_dolar = total_dolar + venta.Cantidad;
          total_propina_dolar = total_propina_dolar + venta.propina;
        }
      });
      this.data_devoluciones.forEach((dev) => {
        //total_pagos = total_pagos + dev.Cantidad;
        //total = total + parseInt(dev.Total);
        //totalCambio = totalCambio + (dev.Cambio ? dev.Cambio.MXN : 0);
        if (dev.moneda === Currencies.getCurrencyDefault()) {
          total_pesos = total_pesos - dev.Cantidad;
        } else {
          total_dolar = total_dolar - dev.Cantidad;
        }
      });
      return {
        total_pesos: total_pesos,
        total_propina_pesos: total_propina_pesos,
        total_dolar: total_dolar,
        total_propina_dolar: total_propina_dolar,
        total_productos: total_products,
        total_rounds: total_golf_round,
        total_proshop: total_proshop,
        total_metodo_pagos: Number(parseFloat(total_pagos).toFixed(2)),
        totalCambio: totalCambio,
        total: total,
      };
    },
    comp_clients() {
      let clientes = [];
      this.getClientes.forEach((cli) => {
        clientes.push({ id: cli.id, text: cli.Apellidos + " " + cli.Nombres });
      });
      return clientes;
    },
    comp_filter() {
      let filter = [];

      this.pagos.forEach((pago) => {
        this.monedas.forEach((moneda) => {
          filter.push(pago + "_" + moneda);
        });
      });
      return filter;
    },
    excel_data() {
      let dataExcel = [];
      this.data_ventas.forEach((venta) => {
        if (venta.show) {
          dataExcel.push({
            Folio: venta.Folio,
            Fecha: venta.FechaVenta,
            Hora: this.formatDate(venta.FechaCreacion),
            Cliente: venta.Cliente.Nombre,
            Alias: venta.Cliente.Apodo,
            Cajero: this.$pgsHelper.getById(this.cajeros, "Id", venta.Cajero)
              .Nomb,
            Autorizacion: venta.IdTran,
            Clave: venta.clave,
            TipoPago: venta.TipoPago,
            Moneda: venta.moneda,
            TotalMetodoPago: venta.Cantidad,
            TotalVenta: this.$pgsHelper.formatNumber(venta.Total),
            // Propina: this.$pgsHelper.formatNumber(venta.PropinaTotal),
            TotalTicket: this.$pgsHelper.formatNumber(
              venta.PropinaTotal + venta.Total
            ),
            // Cambio: this.$pgsHelper.formatNumber(
            //   venta.Cambio ? venta.Cambio.MXN : 0
            // ),
            Estatus: venta.Devos ? "Devuelto" : "Activo",
            Tipo: venta.prop ? "Propina" : venta.camb ? "Cambio" : "Pago",
          });
        }
      });
      this.data_devoluciones.forEach((venta) => {
        if (venta.show) {
          dataExcel.push({
            Folio: venta.Folio,
            Fecha: moment(venta.Fecha).format("YYYY-MM-DD"),
            Hora: this.formatDate(venta.Crat),
            Cliente: venta.Cliente.Nombre,
            Alias: "Devolución",
            Cajero: this.$pgsHelper.getById(this.cajeros, "Id", venta.Cajero)
              .Nomb,
            Autorizacion: venta.IdTran,
            Clave: venta.clave,
            Moneda: venta.moneda,
            TipoPago: venta.TipoPago,
            TotalMetodoPago: 0 - venta.Cantidad,
            TotalVenta: this.$pgsHelper.formatNumber(venta.Cantidad),
            Cambio: 0,
            Estatus: "Devolucion",
            Tipo: venta.prop ? "Propina" : "Pago",
          });
        }
      });
      let data = dataExcel;
      let array = data.sort(function (a, b) {
        if (b.Folio > a.Folio) return -1;
        if (b.Folio < a.Folio) return 1;
      });
      return array;
    },
  },
  methods: {
    getFormattedValue(item, field) {
      const value = item[field];
      if (Array.isArray(value)) {
        // Convierte arrays en una lista legible
        return value
          .map((v) => (typeof v === "object" ? JSON.stringify(v) : v))
          .join(", ");
      }
      if (typeof value === "object" && value !== null) {
        // Convierte objetos a una representación legible
        return JSON.stringify(value);
      }
      return value !== null && value !== undefined ? value.toString() : ""; // Maneja valores simples
    },
    getUniqueValues(key) {
      const field = this.headers.find((f) => f.value === key);

      // Extraer y normalizar valores únicos
      return [
        ...new Set(
          this.data_ventas.flatMap((item) => {
            let value;


            // Usa el valor crudo si no hay formato
            value = item[key] || "";


            // Divide valores múltiples por el delimitador (coma en este caso) y normaliza
            return value
              .toString()
              .split(",")
              .map((v) => v.trim().toUpperCase()); // Normaliza cada valor
          })
        ),
      ];
    },
    selectAll() {
      this.selectedRows = []
      this.ventas_comp.forEach((item) => {
        if (item.show && !item.Mgrt) {
          if (!this.selectedRows.includes(item.id)) {
            this.selectedRows.push(item.id)
          }

        }
      })
      this.isSelectedAll = true
    },
    selecItemRow(id) {
      if (this.selectedRows.includes(id)) {
        const index = this.selectedRows.indexOf(id);
        if (index > -1) { // only splice array when item is found
          this.selectedRows.splice(index, 1); // 2nd parameter means remove one item only
        }
      } else {
        this.selectedRows.push(id)
      }
    },
    clearAll() {

      this.selectedRows = []
      this.isSelectedAll = false
    },
    onCheck() {
      console.log
    },
    exportExcel() {
      TransaccionesExcelExporter.exportReporteTransacciones(
        this.ventas_comp,
        this.devoluciones_comp,
        "Reporte transacciones",
        this.contadoresTotales, this.cajeros
      )
        .then(buffer => {
          const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = "ReporteTransacciones.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(err => console.error("Error exportando Excel:", err));
    },
    async getAperturas() {
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        //firestore.where("Caja", "==", this.$route.params.idInstalacion),
        firestore.where("Tipo", "==", "Apertura"),
      ];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep)
        );
      }
      if (this.selectCaja != "ALL" && this.selectCaja != "") {
        filter.push(firestore.where("Caja", "==", this.selectCaja));
      }
      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);
      //console.log(cierres);
      let aperturas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      aperturas.forEach((apt) => {
        let fecha = new moment(apt.Momento, "YYYY-MM-DD_HH:mm:ss");
        let caja = this.$pgsHelper.getById(this.data_cajas, "id", apt.Caja);
        let cajeroData = this.$pgsHelper.getById(
          this.cajeros,
          "Id",
          apt.Cajero
        );
        apt.CajaData = caja;
        apt.CajeroData = cajeroData;
        apt.CajeroName = cajeroData.Nomb;
        apt.Desc =
          "Turno Fecha " +
          fecha.format("DD-MM-YYYY") +
          " Hora: " +
          fecha.format("HH:mm") +
          " || " +
          caja.Nomb +
          " || " +
          cajeroData.Nomb +
          " || Turno: " +
          apt.Turno;
      });

      this.aperturas = aperturas;
    },
    generatePdf() {
      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        data: this.excel_data,
      };
      let docData = ReporteMetodosPago.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    generatePdfCliente() {
      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        data: this.excel_data,
      };
      let docData = ReporteMetodosPagoCliente.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    async getMeserosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Meseros"
        );
      if (snapshot.exists()) {
        this.meseros = [];
        this.meseros = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
        this.meseros.forEach((mesero) => {
          if (mesero.Deptos) {
            let deptos = Object.entries(mesero.Deptos);
            let textDepto = "";
            deptos.forEach((depto) => {
              let testDepto = this.$pgsHelper.getById(
                this.departamentos,
                "Id",
                depto[0]
              );
              if (testDepto) {
                textDepto = textDepto + testDepto.Nombre + " ";
              }
            });
            mesero.DepartamentoText = textDepto;
          } else {
            mesero.DepartamentoText = "";
          }
        });
      }
    },
    revertMigrate() {
      if (this.departamentoRevert == "") {
        this.$toast.error(" ", `Seleccione un departamento`);
        return false
      }
      this.loading = true
      let data = {
        fecha: this.input_date_revert.format("YYYY-MM-DD"),
        departamento: this.departamentoRevert,
        from: "BOKA",
        to: "CHWO",
        fromTenant: "BOKA",
        toTenant: "CHWO",
      }
      this.$store.getters.getFirebaseApp.fba
        .call("CTB-MigradorDiario-limpiarDia", data)
        .then((result) => {

          if (result.data.ok) {

            this.loading = false
            this.$toast.success(" ", "Migración revertida exitosamente");
            this.cancelToogle = false
            this.data_ventas = []
            this.selectedRows = []
          } else {
            this.$toast.error(" ", result.error);
            this.loading = false
          }

        })
        .catch((error) => {
          this.loading = false
          this.$toast.error(" ", `Request failed: ${error}`);
        });
    },
    sendVentasToEnd() {
      this.loading = true
      let data = {
        departamento: this.selectDep,
        fecha: this.input_date.format("YYYY-MM-DD"),
        ventas: this.selectedRows,
        from: "BOKA",
        to: "CHWO",
        fromTenant: "BOKA",
        toTenant: "CHWO",
      }
      this.$store.getters.getFirebaseApp.fba
        .call("CTB-MigradorDiario-agregarVentasDia", data)
        .then((result) => {

          if (result.data.ok) {
            //console.log(result)
            this.loading = false
            this.$toast.success(" ", "Ventas migradas exitosamente");
            this.confirmDialog = false
            this.data_ventas = []
            this.selectedRows = []
          } else {
            this.$toast.error(" ", result.error);
            this.loading = false
          }

        })
        .catch((error) => {
          this.loading = false
          this.$toast.error(" ", `Request failed: ${error}`);
        });
    },
    sendVentas() {
      this.loading = true
      let data = {
        departamento: this.selectDep,
        fecha: this.input_date.format("YYYY-MM-DD"),
        ventas: this.selectedRows,
        from: "BOKA",
        to: "CHWO",
        fromTenant: "BOKA",
        toTenant: "CHWO",
      }
      this.$store.getters.getFirebaseApp.fba
        .call("CTB-MigradorDiario-migrarDia", data)
        .then((result) => {

          if (result.data.ok) {
            console.log(result)
            this.loading = false
            this.$toast.success(" ", "Ventas migradas exitosamente");
            this.confirmDialog = false
            this.data_ventas = []
            this.selectedRows = []
          }

        })
        .catch((error) => {
          this.loading = false
          this.$toast.error(" ", `Request failed: ${error}`);
        });
    },
    formatDate(timestamp) {
      let d = new Date(timestamp);
      //console.log(new moment(d))
      //let Creacion =   d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
      return new moment(d).format("HH:mm");
    },
    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas"
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.showModal = true;
    },
    selectDate(arg) {
      this.selectedRows = []
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    selectDateRevert(arg) {
      this.input_date_revert = moment(arg);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    selectDateFinal(arg) {
      this.selectedRows = []
      this.input_date_final = moment(arg);
    },
    async getIsMigrated() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const startDate = this.input_date.format("YYYY-MM-DD");
      let filter = [
        firestore.where(
          "Tenant",
          "==",
          "CHWO"
        ),
        firestore.where("FechaVenta", "==", startDate),
        firestore.where("Departamento.id", "==", this.selectDep),
        firestore.limit(1)
      ];
      const data = await firestore.queryBuilder("PDV_Ventas", filter);
      console.log(data.empty)
      if (!data.empty) {
        this.isMigrated = true
      }
    },
    async getVentas() {
      this.isMigrated = false
      this.getIsMigrated()
      this.selectedRows = []
      this.loadingData = true;
      let turnos = [];
      if (this.selectTurno != "ALL") {
        turnos.push(this.selectTurno);
      } else {
        this.aperturas.forEach((de) => {
          turnos.push(de.Turno);
        });
      }
      let arrayFilter = this.pagos;
      if (this.transaccion) {
        arrayFilter = arrayFilter.map((pago) => {
          return pago + "-" + this.transaccion;
        });
      }
      let listVentas = [];
      let taskTurnos = turnos.map(async (id) => {
        const firestore = this.$store.getters.getFirebaseApp.firestore;
        let filter = [
          firestore.where("Turno", "==", id),

          firestore.where(
            "Tenant",
            "==",
            this.$store.getters.getFirebaseApp.tenant
          ),
        ];

        if (this.selectDep != "ALL" && this.selectDep != "") {
          filter.push(firestore.where("Departamento", "==", this.selectDep));
        }
        /*if (arrayFilter.length > 0) {
        filter.push(
          firestore.where("_PagoIdx", "array-contains-any", arrayFilter)
        );
      }*/
        if (this.input_folio != "") {
          filter.push(firestore.where("Folio", "==", this.input_folio));
        }

        if (this.selectClient != "") {
          filter.push(firestore.where("Cliente.Id", "==", this.selectClient));
        }

        if (this.input_cajero != "") {
          filter.push(firestore.where("Cajero", "==", this.input_cajero));
        }

        if (this.selectCaja != "") {
          filter.push(firestore.where("Caja", "==", this.selectCaja));
        }

        const data = await firestore.queryBuilder("PDV_Ventas", filter);
        let preData = [];
        preData = data.docs.map((doc) => {
          listVentas.push({ id: doc.ref.id, ...doc.data() });
          return { id: doc.ref.id, ...doc.data() };
        });
      });
      let data_ventas = [];
      await Promise.all(taskTurnos).then((turnos) => {
        data_ventas = listVentas;
      });

      let ventas = [];
      data_ventas.forEach((venta) => {
        let propsMxn = 0;
        let propUSD = 0;

        if (venta.Props) {
          let propinas = Object.entries(venta.Props);

          propinas.forEach((prop) => {
            let propSplit = prop[0].split("_");
            if (propSplit[1] == Currencies.getCurrencyDefault()) {
              propsMxn = propsMxn + prop[1].Cantidad;
            } else if (propSplit[1] == "USD") {
              propUSD = propUSD + prop[1].Cantidad;
            }
          });

          propinas.forEach((prop) => {
            let propSplit = prop[0].split("_");

            let tipopago = this.$pgsHelper.getById(
              this.getPDVPagosTipos,
              "id",
              propSplit[0]
            ).Nombre;

            if (arrayFilter.length > 0) {
              ventas.push({
                prop: true,
                IdTran: "",
                TipoPago: tipopago + " " + propSplit[1] + " Propina",
                Cantidad: prop[1].Cantidad,
                moneda: propSplit[1],
                PropinaTotal: propsMxn,
                PropinaUSD: propUSD,
                clave: propSplit[0] + "_" + propSplit[1],
                show: this.comp_filter.includes(
                  propSplit[0] + "_" + propSplit[1]
                ),
                ...venta,
              });
            } else {
              ventas.push({
                prop: true,
                IdTran: "",
                TipoPago: tipopago + " " + propSplit[1] + " Propina",
                Cantidad: prop[1].Cantidad,
                moneda: propSplit[1],
                PropinaTotal: propsMxn,
                PropinaUSD: propUSD,
                clave: propSplit[0] + "_" + propSplit[1],
                show: true,
                ...venta,
              });
            }
          });
        }
        venta.PropinaTotal = propsMxn;
        venta.PropinaUSD = propUSD;

        if (venta.Cambio && venta.Cambio[Currencies.getCurrencyDefault()] > 0) {
          const negativeChange =
            -1 * Number(parseFloat(venta.Cambio[Currencies.getCurrencyDefault()]).toFixed(2));
          if (arrayFilter.length > 0) {
            ventas.push({
              camb: true,
              IdTran: "",
              TipoPago: "Cambio " + Currencies.getCurrencyDefault(),
              Cantidad: Number(negativeChange),
              moneda: Currencies.getCurrencyDefault(),
              clave: "EFVO_" + Currencies.getCurrencyDefault(),
              show: this.comp_filter.includes(Currencies.getCurrencyDefault()),
              ...venta,
            });
          } else {
            ventas.push({
              camb: true,
              IdTran: "",
              TipoPago: "Cambio " + Currencies.getCurrencyDefault(),
              Cantidad: Number(negativeChange),
              moneda: Currencies.getCurrencyDefault(),
              clave: "EFVO_" + Currencies.getCurrencyDefault(),
              show: true,
              ...venta,
            });
          }
        }

        let pagos = Object.entries(venta.Pagos);
        pagos.forEach((pago) => {
          //if (pago[1].IdTran) {
          if (arrayFilter.length > 0) {
            //this.comp_filter.forEach((Filter) => {
            //if (pago[0].includes(Filter)) {
            ventas.push({
              IdTran: pago[1].IdTran,
              TipoPago: pago[1].TipoPago,
              Cantidad: pago[1].Cantidad,
              moneda: pago[1].Moneda,
              propina: venta.Props
                ? venta.Props[pago[0]]
                  ? venta.Props[pago[0]].Cantidad
                  : 0
                : 0,
              clave: pago[0],
              show: this.comp_filter.includes(pago[0]),
              ...venta,
            });
            //}
            // });
          } else {
            ventas.push({
              IdTran: pago[1].IdTran,
              TipoPago: pago[1].TipoPago,
              Cantidad: pago[1].Cantidad,
              moneda: pago[1].Moneda,
              //propina: (pago[1].Props)?((pago[1].Props[pago[0]])?pago[1].Props[pago[0]]:0):0,
              propina: venta.Props
                ? venta.Props[pago[0]]
                  ? venta.Props[pago[0]].Cantidad
                  : 0
                : 0,
              clave: pago[0],
              show: true,
              ...venta,
            });
          }

          //}
        });
        if (venta.Mgrt) {
          console.log(venta.Mgrt)
          this.isMigrated = true
        }
      });
      this.data_ventas = [];

      this.ventasSnapshot = data_ventas;
      if (this.clientesSelected.length > 0) {
        ventas.forEach((ven, index) => {
          ven.idUnico = ven.Folio + "-" + index
          if (ven.show) {
            if (this.clientesSelected.includes(ven.Cliente.Id)) {
              ven.show = true;
            } else {
              ven.show = false;
            }
          }
        });
      }
      this.data_ventas = ventas;

      this.showEstad = true;
      this.loadingData = false;
    },
    async getDevoluciones() {
      this.loadingData = true;
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      let arrayFilter = this.pagos;
      let turnos = [];
      if (this.selectTurno != "ALL") {
        turnos.push(this.selectTurno);
      } else {
        this.aperturas.forEach((de) => {
          turnos.push(de.Turno);
        });
      }
      if (this.transaccion) {
        arrayFilter = arrayFilter.map((pago) => {
          return pago + "-" + this.transaccion;
        });
      }
      let listVentas = [];
      let taskTurnos = turnos.map(async (id) => {
        const firestore = this.$store.getters.getFirebaseApp.firestore;
        let filter = [
          firestore.where("Turno", "==", id),

          firestore.where(
            "Tenant",
            "==",
            this.$store.getters.getFirebaseApp.tenant
          ),
        ];

        if (this.selectDep != "ALL" && this.selectDep != "") {
          filter.push(firestore.where("Departamento", "==", this.selectDep));
        }
        /*if (arrayFilter.length > 0) {
        filter.push(
          firestore.where("_PagoIdx", "array-contains-any", arrayFilter)
        );
      }*/
        if (this.input_folio != "") {
          filter.push(firestore.where("Folio", "==", this.input_folio));
        }

        if (this.selectClient != "") {
          filter.push(firestore.where("Cliente.Id", "==", this.selectClient));
        }

        if (this.input_cajero != "") {
          filter.push(firestore.where("Cajero", "==", this.input_cajero));
        }

        if (this.selectCaja != "") {
          filter.push(firestore.where("Caja", "==", this.selectCaja));
        }

        const data = await firestore.queryBuilder("PDV_Devoluciones", filter);
        let preData = [];
        preData = data.docs.map((doc) => {
          listVentas.push({ id: doc.ref.id, ...doc.data() });
          return { id: doc.ref.id, ...doc.data() };
        });
      });
      let data_ventas = [];
      await Promise.all(taskTurnos).then((turnos) => {
        data_ventas = listVentas;
      });

      let ventas = [];
      data_ventas.forEach((venta) => {
        if (venta.Devs) {
          let propinas = Object.entries(venta.Depr);
          let propsMxn = 0;
          let propUSD = 0;

          propinas.forEach((prop) => {
            let propSplit = prop[0].split("_");
            if (propSplit[1] == Currencies.getCurrencyDefault()) {
              propsMxn = propsMxn + prop[1];
            } else if (propSplit[1] == "USD") {
              propUSD = propUSD + prop[1];
            }
          });

          propinas.forEach((prop) => {
            let propSplit = prop[0].split("_");

            let tipopago = this.$pgsHelper.getById(
              this.getPDVPagosTipos,
              "id",
              propSplit[0]
            ).Nombre;

            if (arrayFilter.length > 0) {
              ventas.push({
                prop: true,
                IdTran: "",
                TipoPago: tipopago + " " + propSplit[1] + " Propina",
                Cantidad: prop[1],
                moneda: propSplit[1],
                PropinaTotal: propsMxn,
                PropinaUSD: propUSD,
                clave: propSplit[0] + "_" + propSplit[1],
                show: this.comp_filter.includes(
                  propSplit[0] + "_" + propSplit[1]
                ),
                ...venta,
              });
            } else {
              ventas.push({
                prop: true,
                IdTran: "",
                TipoPago: tipopago + " " + propSplit[1] + " Propina",
                Cantidad: prop[1],
                moneda: propSplit[1],
                PropinaTotal: propsMxn,
                PropinaUSD: propUSD,
                clave: propSplit[0] + "_" + propSplit[1],
                show: true,
                ...venta,
              });
            }
          });
        }

        /*if (venta.Cambio && venta.Cambio["MXN"] > 0) {
          if (arrayFilter.length > 0) {
            ventas.push({
              camb: true,
              IdTran: "",
              TipoPago: "Cambio ",
              Cantidad: venta.Cambio["MXN"],
              moneda: "MXN",
              clave: "MXN",
              show: this.comp_filter.includes("MXN"),
              ...venta,
            });
          } else {
            ventas.push({
              camb: true,
              IdTran: "",
              TipoPago: "Cambio ",
              Cantidad: venta.Cambio["MXN"],
              moneda: "MXN",
              clave: "MXN",
              show: true,
              ...venta,
            });
          }
        } */

        let pagos = Object.entries(venta.Devs);
        pagos.forEach((pago) => {
          let splitPago = pago[0].split("_");
          let pagoMoneda = this.$pgsHelper.getById(
            this.getPDVMonedasLista,
            "id",
            splitPago[1]
          );
          let pagoMpago = this.$pgsHelper.getById(
            this.getPDVPagosTipos,
            "id",
            splitPago[0]
          );
          if (arrayFilter.length > 0) {
            //this.comp_filter.forEach((Filter) => {
            //if (pago[0].includes(Filter)) {
            ventas.push({
              IdTran: "",
              TipoPago: pagoMpago.Nombre,
              Cantidad: pago[1],
              moneda: splitPago[1],
              clave: pago[0],
              show: this.comp_filter.includes(pago[0]),
              ...venta,
            });
            //}
            // });
          } else {
            ventas.push({
              IdTran: "",
              TipoPago: pagoMpago.Nombre,
              Cantidad: pago[1],
              moneda: splitPago[1],
              clave: pago[0],
              show: true,
              ...venta,
            });
          }
        });
      });
      this.devolucionesSnapshot = data_ventas;
      if (this.clientesSelected.length > 0) {
        ventas.forEach((ven) => {
          if (ven.show) {
            if (this.clientesSelected.includes(ven.Cliente.Id)) {
              ven.show = true;
            } else {
              ven.show = false;
            }
          }
        });
      }
      this.data_devoluciones = ventas;

      this.showEstad = true;
      this.loadingData = false;
    },
    async getCajeros() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cajeros = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cajeros.push(toAdd);
          }
        });
      }
    },
  },
  async mounted() {
    await this.getAperturas();
    this.getCajas();
    this.getCajeros();
    this.getMeserosAB();
  },
  beforeCreate: function () { },
  beforeMount: function () {
    this.$emit("useNav", true);
  },
};
</script>

<style scoped>
.backgroundProp {
  background-color: lightcyan;
}

.backgroundCamb {
  background-color: lightgoldenrodyellow;
}

.activeClass {
  background: #2185d075 !important;
}

.cardTotal {
  margin-left: -12px;
  position: fixed;
  bottom: 0;
}

::v-deep .vdp-datepicker__calendar {
  position: fixed;
}
</style>
